import { AlignCenterOutlined, AlignLeftOutlined, AlignRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Namespace } from '@data/utils/enums';
import { Button } from '@ui/components';
import { getIconStyles } from '../../utils';
import { useAlign } from './hooks';

const iconStyles = getIconStyles();

type AlignProps = {
  disabled: boolean;
};

export const Align = ({ disabled }: AlignProps) => {
  const { handleAlign } = useAlign();
  const { t } = useTranslation([Namespace.ADMIN]);

  return (
    <div className="flex items-center gap-1">
      <Button
        type="text"
        disabled={disabled}
        className="p-2 rounded-md"
        onClick={() => handleAlign('left')}
        title={t('editor.titles.align_left')}
      >
        <AlignLeftOutlined style={iconStyles} />
      </Button>
      <Button
        type="text"
        disabled={disabled}
        className="p-2 rounded-md"
        onClick={() => handleAlign('center')}
        title={t('editor.titles.align_center')}
      >
        <AlignCenterOutlined style={iconStyles} />
      </Button>
      <Button
        type="text"
        disabled={disabled}
        className="p-2 rounded-md"
        onClick={() => handleAlign('right')}
        title={t('editor.titles.Align_right')}
      >
        <AlignRightOutlined style={iconStyles} />
      </Button>
    </div>
  );
};
